// angular
// 	.module("HeroPRO")
// 	.controller("CallInProductsController", CallInProductsController);

import './callInProducts.scss';

/* @ngInject */
export default function CallInProductsController(FRInformationFactory, HPConfig, ModalService, $analytics, DealTypeFactory, AddProductsFactory) {
    const vm = this;
    vm.appInfo = {};
    vm.address = '';
    vm.showLeaseOption = false;
    vm.showDirectPayOption = false;
    vm.dealTypeDataLoaded = false;
    vm.selectedDealType = null;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
	 vm.openAddProductsModal = function (visibleModules) {
        ModalService.launchLgModal({
            templateUrl: 'app/appDetail/addProducts/addProductsModal.html',
            windowClass: 'add-products-modal full-screen',
            controller: 'AddProductsModalController',
            controllerAs: 'addProductsModal',
            size: 'full-screen',
            animation: false,
            resolve: {
                visibleModules() {
                    return visibleModules || [];
                },
            },
        });

        $analytics.eventTrack('Open Add Product Modal', { category: 'Walkthrough' });
    };

    vm.openAddProductsWebsite = function() {
        AddProductsFactory.openAddProductsWebsite();
    }
    /* -----  End of Public Functions  ------*/


    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
    function init() {
        FRInformationFactory.getFundingRequestInformationPromise().then(() => {
            vm.appInfo = FRInformationFactory.getAppInfo();
            vm.address = `${vm.appInfo.Address.Address1} ${vm.appInfo.Address.City}, ${vm.appInfo.Address.State} ${vm.appInfo.Address.ZIPCode}`;
            vm.productsLink = `${HPConfig.heroProLink}/product-lookup/directory/${vm.appInfo.Address.State}/`;

            vm.callInProductsReason = 'Call us to specify product, total costs and financing terms.';

            if (vm.appInfo.CanAddProductsOnline === 1) { // UncommonOwnership = 1,
                vm.callInProductsReason = 'Call us to specify product, total costs and financing terms.';
            } else if (vm.appInfo.CanAddProductsOnline === 2) { // LoanHasMultiRate = 2,
                vm.callInProductsReason = 'Call us to specify product, total costs and financing terms.';
            } else if (vm.appInfo.CanAddProductsOnline === 3) { // ApplicationExpired = 3,
                vm.callInProductsReason = 'This file is expired. Please contact us at';
            } else if (vm.appInfo.CanAddProductsOnline === 4) { // LoanLocked = 4
                vm.callInProductsReason = 'This file requires additional information. Please contact us at';
            }

            processDealType();
        });
    }

    function processDealType() {
    // Check if the deal type has already been set
        if (DealTypeFactory.getSelectedDealType().DealTypeId) {
            // Deal type has been set
            vm.selectedDealType = DealTypeFactory.getSelectedDealType();
            vm.dealTypeDataLoaded = true;
        } else {
            // Deal type has not been set, retrieve available deal types
            const params = {
                LoanId: vm.appInfo.LoanId,
                ContractorLocationId: vm.appInfo.Contractor.ContractorLocationId,
            };

            DealTypeFactory.fetchAvailableDealTypes(params).then(() => {
                if (DealTypeFactory.hasLeaseDealType() === true) {
                    vm.showLeaseOption = true;
                }

                if (DealTypeFactory.hasDirectPayDealType() === true) {
                    vm.showDirectPayOption = true;
                }

                vm.dealTypeDataLoaded = true;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/application/CallInProductsController.js